module.exports = __webpack_public_path__ + "static/media/portfolio.f56e6d84.PNG";